import { Alert, AppBar, Box, Button, CardMedia, Modal, Snackbar, Stack, Toolbar, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useFetch } from '../../hook/useFetch'
import { rutas } from '../../rutas/rutas'
import tierra1 from '../../Web Mundo/GIF-ISLA-1HS_yzyprs_1_pnzh53.gif'
import tierra2 from '../../Web Mundo/TIERRA-HUESO-GIF_vcj73t_ji8wkf.gif'
import tierra3 from '../../Web Mundo/ISLA-ENERGIA_x5cvlq_ojo9ia.gif'
import tierra4 from '../../Web Mundo/swap.gif'
import tierra5 from '../../Web Mundo/tierra5.gif'
import info from '../../Web Mundo/fondo_mensajes_bdb.jpg'
//import fondo from '../../Web Mundo/fondoweb.png'
import { Cronometro } from '../cronometro/Cronometro'
import { useDispatch, useSelector } from 'react-redux'
import { setInformacion } from '../../storage/slices/usuarios'
import { Link, useNavigate } from 'react-router-dom'
import { getCookie } from '../../utils/getCookie'
import axios from 'axios'
import { Container } from '@mui/system'
import fondo from '../../Web Mundo/Fondo_new_islas_lhtanv.png'
import { ModalPool } from './ModalPool'
import ContainerEventoIcono  from "../../style/HomeGameStyle";
import { Hueso } from '../ecosistema/Hueso'
import dayjs from 'dayjs'

//const fondo = 'https://res.cloudinary.com/dbav8xw6s/image/upload/f_auto,q_26/v1669377765/FONDOS%20NAVIDE%C3%91OS/fondo_navidad_vhwqjk.png'
//'https://res.cloudinary.com/dbav8xw6s/image/upload/v1666558952/hueso/assets/VARIADAS/fondowebHW_pdno9u.png'

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 500, md: 1000 },
  height: {xs: '80%' ,md: '70%' },
  overflow: 'auto',
  boxShadow: 24,
  p: 2,
};

export const Inicio = () => {
  const [peticion] = useFetch()
  const {informacion} = useSelector(state=> state.userSlice)
  const dispatch = useDispatch()
  const [open2, setOpen2] = React.useState(false);
  const handleClose2 = () => setOpen2(false);
  const [open, setOpen] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleClose3 = () => setOpen3(false);
  const [error, setError] = React.useState(false);
  const [timeServer, setTimeServer] = React.useState('');
  const navigate = useNavigate()
  const [ mensaje, setMensaje ] = React.useState('')
  const [ control, setControl ] = React.useState(false)
  const [open9, setOpen9] = React.useState(false);
  const [errorText, setErrorText] = React.useState("Error");
  

  const comprar = () =>{
    navigate('/game/market', {
      replace:true
    })
  }
  const handleClose9 = () => {
    setOpen9(false);
  };
  useEffect(()=>{
    if(control){
      setOpen3(true)
    }

  },[control])
  console.log(informacion?.especial, 'informacion?.especial')
  useEffect(()=>{
    const tokenJWT = getCookie('token')
         
    axios.get(`${rutas.getInformacion}`, { headers: {'token': tokenJWT}})
    .then(res=> {
  
        if(res.data?.resultado?.hora)setTimeServer(res.data?.resultado?.hora)
        if(res.data?.mensajes)setMensaje(res.data?.mensajes)
        setControl(true)
        setTimeout(()=>setControl(false), 7000)
   
    })
  },[])
    const mision = async (tipo) => {
  try {
if (
  tipo === 4 &&
  !["mv-deposito", "lavino"].includes(informacion?.nombre)
) {
  return setErrorText("It is not yet available, it will be soon.");
}    const resultado = await peticion(rutas.mision, "post", {mision: tipo})
 
    if(resultado) {
      dispatch(setInformacion(resultado?.usuario));
      
      // Agregar alerta de éxito para todas las misiones
      setError(false);
      if(tipo === 4) {
        setErrorText("4-hour special mission started successfully");
      } else if(tipo === 1) {
        setErrorText("1-hour mission started successfully");
      } else if(tipo === 6) {
        setErrorText("6-hour mission started successfully");
      } else if(tipo === 3) {
        setErrorText("Energy recharge mission started successfully");
      }
      setOpen2(true);
    }
    
  } catch (error) {
    setErrorText(error?.response?.data?.error)
    setError(true)
    setOpen2(true)
  }
}

     // Función para finalizar misiones 
 
    // Función para verificar si la misión especial puede reclamarse
const puedeReclamarEspecial = () => {
  if (!informacion?.misionEspecial?.start || !informacion?.misionEspecial?.Tiempo) {
    return false;
  }
  
  const ahora = dayjs();
  const tiempoFin = dayjs(informacion.misionEspecial.Tiempo);
  return ahora.isAfter(tiempoFin) || ahora.isSame(tiempoFin);
};

    return (
      <Box sx={{ height: '100%',width: '100%', position: 'relative' }}>
    {/* Cronómetro misión normal */}
    { timeServer !== '' && informacion?.mision?.start && <AppBar sx={{position: 'relative'}}>
        <Toolbar disableGutters variant='dense' sx={{background: 'rgba(255,255,255,0.1)', display: 'flex',justifyContent: 'center'}}>
          <Cronometro  tipo={"normal"} timeServer={timeServer} time={informacion?.mision?.Tiempo}/>
        </Toolbar>
        </AppBar>
    }
    
    {/* Cronómetro misión especial */}
    { timeServer !== '' && informacion?.misionEspecial?.start && <AppBar sx={{position: 'relative'}}>
        <Toolbar disableGutters variant='dense' sx={{background: 'rgba(255,165,0,0.8)', display: 'flex',justifyContent: 'center'}}>
          <Typography sx={{color: 'white', fontWeight: 'bold'}}>ESPECIAL: </Typography>
          <Cronometro tipo={"especial"} timeServer={timeServer} time={informacion?.misionEspecial?.Tiempo}/>
        </Toolbar>
        </AppBar>
    }
      
     
      <Box sx={{backgroundImage: `url(${"https://res.cloudinary.com/druu0mcam/image/upload/v1719339319/Dise%C3%B1o_sin_t%C3%ADtulo_56_htku49_qnv3i1.png"})`,backgroundPosition: 'bottom', backgroundSize: 'cover' ,  height: {md: '100%', lg: '100vh'} ,display: 'flex', justifyContent: 'start', flexDirection:{ xs: 'column', md: 'row'}, alignItems: 'top', flexWrap: 'wrap', gap: '30px'}}>
        
        <Box sx={{ width: {xs: '90%', md: '30%'}, height: {xs: '30vh', md: '30vh'}}}>
        <CardMedia
          component="img"
          sx={{ width: '100%'}}
          image={tierra1}
          alt="Paella dish"
        />
           <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>

            <Typography sx={{color: "red"}}>{informacion?.costos?.primera} - energy</Typography>
            <Typography sx={{color: "red"}}>1 - {informacion?.poder + 80 } HUESOS</Typography>
         <Button disabled={informacion?.mision?.start } onClick={ ()=>mision(1)} variant='contained'>Dig 1 hour</Button>
          </Box>
        </Box>
        <Box sx={{ width: {xs: '90%', md: '30%'}, height: {xs: '30vh', md: '30vh'}}}>

        <CardMedia
          component="img"
          sx={{ width: '80%'}}
          image={tierra3}
          alt="Paella dish"
        />
           <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>
           <Typography sx={{color: "red"}}>{informacion?.poderEnergia + 2} energy</Typography>
      
           
             <Button disabled={informacion?.mision?.start } onClick={ ()=>mision(3)} variant='contained'>Recharge</Button> 
          </Box>
        </Box>
        <Box sx={{ width: {xs: '90%', md: '30%'}, height: {xs: '30vh', md: '30vh'}}}>

        <CardMedia
          component="img"
          sx={{ width: '80%'}}
          image={tierra2}
          alt="Paella dish"
        />
          <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>
          <Typography sx={{color: "red"}}>{informacion?.costos?.segunda} - energy</Typography>
          <Typography sx={{color: "red"}}>10 -  {informacion?.poder * 5 + 400 } HUESOS</Typography>
         
            <Button disabled={informacion?.mision?.start } onClick={ ()=>mision(6)} variant='contained'>Walk 6 hours</Button>
            
          </Box>
          
        </Box>
   
        <Box sx={{ width: {xs: '90%', md: '30%'}, height: {xs: '50vh', md: '50vh'}, marginTop: 9}}>

  <CardMedia
    component="img"
    sx={{ width: '60%', m:4}}
    image={tierra4}
    alt="Paella dish"
  />
     <Box sx={{display: 'flex', justifyContent: 'space-evenly'}}>


     
      {informacion?.packInicial ?  <Button  onClick={ ()=>handleOpen(3)} variant='contained'>Pool</Button> :  <Button onClick={ ()=>comprar()} variant='contained'>Buy Island</Button>}
    </Box>
   
  </Box>
  <Box sx={{ width: {xs: '90%', md: '25%'}, height: {xs: '50vh', md: '50vh'}, marginTop: 12, display: "flex", justifyContent: "center",alignItems: "flex-start", flexDirection: "column"}}>

<CardMedia
  component="img"
  sx={{ width: '80%'}}
  image={"https://res.cloudinary.com/druu0mcam/image/upload/v1719339315/swap-_3_rrlyrk_i8zkan.gif"}
  alt="Paella dish"
/>
  <Box sx={{display: 'flex', justifyContent: 'flex-end', width: "100%"}}>
  
 
    <Button disabled={true }  variant='contained'>Coming soon</Button>
    
  </Box>
  
</Box>

<Box sx={{ width: {xs: '90%', md: '25%'}, height: {xs: '50vh', md: '50vh'}, marginTop: 12, display: "flex", justifyContent: "center",alignItems: "flex-start", flexDirection: "column"}}>

<CardMedia
  component="img"
  sx={{ width: '80%'}}
  image={tierra5}
  alt="tierra"
/>
  <Box sx={{display: 'flex', justifyContent: 'flex-end', width: "100%"}}>
  
    <Box sx={{display: 'flex', justifyContent: 'space-evenly', gap:1, width: '100%'}}>
    
      <Typography sx={{color: "red"}}>
       
        {((informacion?.costos?.primera * 2) + 5)} - energy
      </Typography>
      <Typography sx={{color: "red"}}>
        1 - {(informacion?.poder + 200)} HUESOS
      </Typography>
    
      
        <Button 
          disabled={informacion?.misionEspecial?.start} 
          onClick={() => mision(4)} 
          variant='contained'
        >
          Dig 4 hours
        </Button>
      
    </Box>
    
  </Box>
  
</Box>


      </Box>
   {/* <Modal
      open={open3}
      onClose={handleClose3}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{...style, overflow: 'hidden', width: {xs: 350, md: 500}, height: {xs: 350, md: 350},p:0}}>
    <Link to='/game/album/'>
    <CardMedia
          component="img"
          sx={{ width: '100%'}}
          image={"https://res.cloudinary.com/druu0mcam/image/upload_v1719339316/feliz_cumplea%C3%B1os_6_j9wcpi_pqhfhq.png"}
          alt="Paella dish"
        />
    </Link>
      </Box>
    </Modal> */}
      {control && <AppBar sx={{position:"sticky", bottom: 0, height: '100px' }}  position="static">
      <Container maxWidth="xl">
      <Toolbar disableGutters sx={{display: 'flex', color: 'black',justifyContent: 'center',  background: 'orange',alignItems:'center', textAlign: 'center'}}>
        <Typography sx={{ fontSize: '1.2rem'}}>
          {mensaje}
    
        </Typography>
      </Toolbar>
      </Container>
      </AppBar>}

          <ModalPool handleClose={handleClose} open={open} />
      <Stack spacing={2} sx={{ width: "100%" }}>
            <Snackbar open={open2} autoHideDuration={6000} onClose={handleClose2}>
          {
             error ?   <Alert
                onClose={handleClose2}
                severity="error"
                variant="filled" 
                sx={{ width: "100%" }}
              >
                {errorText}
              </Alert>
              :
              <Alert
                onClose={handleClose2}
                severity="success"
                variant="filled" 
                sx={{ width: "100%" }}
              >
                Success
              </Alert>
          }
            </Snackbar>
          </Stack>
          <Modal
            open={open9}
            onClose={handleClose9}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="bordes scroll scroll-small"  sx={style}>
              <Box sx={{textAlign: 'center'}}>
                
                <Typography variant="h3">ECOSYSTEM</Typography>
                <Typography variant="h6">  'Here you will find a list of projects created or where the creator and owner of the game king of duels "LAVINO" participates.'</Typography>
            
              </Box>
              <Hueso />

        </Box>
            </Modal>
          <Box
              onClick={() => setOpen9(true)}
            sx={{
              position: "absolute",
              top: 100,
             cursor: 'pointer',
              right:{xs:  90, lg: 20},
              width: { xs: "50px", sm: '80px', lg: "130px" },
              height: { xs: "50px",sm: '70px',  lg: "90px" },
              display: 'flex', justifyContent: 'center', zIndex: 10
            }}
          >
            <ContainerEventoIcono>
             
            <CardMedia
              component="img"
              image={'https://res.cloudinary.com/dygipivad/image/upload_v1678752309/KOD/boton/My_project-1_25_sqbxym.png'}
              alt="Paella dish"
              sx={{ width: "120px", height: '30px',position: "relative", zIndex: 10}}
       
            />
            </ContainerEventoIcono>
        
          </Box>
      </Box>
    )
  }
